import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { resetPassword } from '../actions/member';

class ForgotPassword extends Component {
  static propTypes = {
    Layout: PropTypes.func.isRequired,
    member: PropTypes.shape({}).isRequired,
    onFormSubmit: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  }

  state = {
    error: null,
    success: null,
    loading: false,
  }

  onFormSubmit = (data, language) => {
    const { onFormSubmit } = this.props;
    const { email } = data;

    this.setState({ loading: true });

    return onFormSubmit(data, language)
      .then(() => this.setState({
        loading: false,
        success: 'auth/success-password-emailed',
        submittedEmail: email,
        error: null,
      })).catch((err) => {
        this.setState({
          loading: false,
          success: null,
          error: err.code,
          submittedEmail: email,
        });
        throw err; // To prevent transition back
      });
  }

  render = () => {
    const { member, Layout, history, } = this.props;
    const { error, loading, success } = this.state;

    return (
      <Layout
        error={error}
        member={member}
        loading={loading}
        success={success}
        history={history}
        onFormSubmit={this.onFormSubmit}
      />
    );
  }
}

const mapStateToProps = state => ({
  member: state.member || {},
});

const mapDispatchToProps = {
  onFormSubmit: resetPassword,
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
